import { render, staticRenderFns } from "./Row.vue?vue&type=template&id=6ba398ce&scoped=true"
var script = {}
import style0 from "./Row.vue?vue&type=style&index=0&id=6ba398ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba398ce",
  null
  
)

export default component.exports